import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getOwsSummary } from '../services/owsService'
import useNotifications from './useNotifications'

export default function useOws(owsId) {
  const { t } = useTranslation()
  const [currentOws, setCurrentOws] = useState()
  const { error } = useNotifications()

  const fetchCurrentOws = useCallback(() => {
    setCurrentOws()
    if (owsId) {
      getOwsSummary(owsId)
        .then((results) => {
          const currentOwsWithMetadata = {
            ...results.data,
            metadata: {
              header: t('ows.ordinanceWorkSet', 'Ordinance Work Set'),
              items: [
                {
                  itemType: 'single',
                  label: t('ows.owsId', 'OWS ID'),
                  showLabel: true,
                  value: {
                    value: results.data.owsId || results.data.templePlatform.ordinanceWorkSets[0].id,
                  },
                },
              ],
            },
          }
          setCurrentOws(currentOwsWithMetadata)
        })
        .catch((err) => {
          error(
            t('ows.errors.gettingOws', {
              defaultValue: `Error getting OWS: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
        })
    } else {
      setCurrentOws(null)
    }
  }, [error, owsId, t])

  React.useEffect(() => {
    fetchCurrentOws(owsId)
  }, [fetchCurrentOws, owsId])

  return { currentOws, setCurrentOws, fetchCurrentOws }
}
